import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Link, Button, Drawer, Typography, Avatar, Stack } from '@mui/material';
// mock
import account from '../../../_mock/account';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// components
import Logo from '../../../components/logo';
import Scrollbar from '../../../components/scrollbar';
import NavSection from '../../../components/nav-section';
//
import {adminHeadNavConfig, liceneseManagerNavConfig, financeControllerNavConfig, accountManagerNavConfig, adminManagerNavConfig, powerUserNavConfig, userNavConfig, viewerNavConfig} from './config';

// ----------------------------------------------------------------------

const NAV_WIDTH = 240;

const StyledAccount = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),

}));

// ----------------------------------------------------------------------

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ openNav, onCloseNav }) {
  const { pathname } = useLocation();
  const loggedUser = useSelector((state) => state.adminUser.user)
// console.log(loggedUser)
  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Box sx={{ display:'flex', alignItems:'center' , justifyContent:'center' }}>
        <Logo sx={{height:'100px', width:'80px', my:2}}/>
      </Box>

      <Box sx={{ mx: 2.5 }}>
        <Link underline="none">
          <StyledAccount>
            <Avatar src={account.photoURL} alt={loggedUser.firstName} />

            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                {loggedUser.firstName} {loggedUser.lastName}
              </Typography>

              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {loggedUser.role}
              </Typography>
            </Box>
          </StyledAccount>
        </Link>
      </Box>

      {loggedUser.role === 'adminhead' && <NavSection data={adminHeadNavConfig} />}
      {loggedUser.role === 'licensemanager' && <NavSection data={liceneseManagerNavConfig} />}
      {loggedUser.role === 'financecontroller' && <NavSection data={financeControllerNavConfig} />}
      {loggedUser.role === 'accountmanager' && <NavSection data={accountManagerNavConfig} />}
      {loggedUser.role === 'adminmanager' && <NavSection data={adminManagerNavConfig} />}
      {loggedUser.role === 'poweruser' && <NavSection data={powerUserNavConfig} />}
      {loggedUser.role === 'user' && <NavSection data={userNavConfig} />}
      {loggedUser.role === 'viewer' && <NavSection data={viewerNavConfig} />}

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV_WIDTH },
        backgroundColor:'#000'
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              bgcolor: loggedUser.isSuperAdmin ? '#eedede' : '#c9d9ff',
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: NAV_WIDTH, bgcolor: loggedUser.isSuperAdmin ? '#eedede' : '#c9d9ff', },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
